// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Breadcrumbs----Breadcrumbs-module---container---3wytm","link":"src-components-Breadcrumbs----Breadcrumbs-module---link---1f7sg","current":"src-components-Breadcrumbs----Breadcrumbs-module---current---3usHj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Breadcrumbs/Breadcrumbs.module.scss
// module id = 1167
// module chunks = 114276838955818